import { render } from "./department.vue?vue&type=template&id=2acbb5b5&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"

import "./department.vue?vue&type=style&index=0&id=2acbb5b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acbb5b5"]])

export default __exports__